/** Original signage for Low Borough. All names are fictional. */

export const SHOP_NAMES = [
  'Lark & Sons Turf Accountants',
  'Golden Plaice Fish Bar',
  'Merrow Radio & TV Rentals',
  'Suds Launderette',
  "Fenner's Hardware",
  'Abbot Bros. Family Butchers',
  "Pell's Tobacconist",
  'Kessmouth Co-operative',
  'Dandy Gents Outfitters',
  'Marigold Bakery',
  'S. Rubin Pawnbroker',
  'Vesey Dispensing Chemist',
  'Tallis Records',
  'Hobbs Newsagent',
  'Kipper & Daughter Ironmongers',
  'Orchid Ladies Hairdresser',
  'Corran Cycle & Motor Spares',
  'W. Ashdown Funeral Directors',
  'Electric Palace Amusements',
  'Gilt Edge Tea Rooms',
  'Bright Spark Electrical',
  'The Wool Basket',
  'Saddler Greengrocer',
  "Nell's Wet Fish",
  'Gullet Grill',
  'A. Pinto Shoe Repairs',
];

export const CAFE_NAMES = ["Sunbeam Café", "Dino's Snack Bar", 'The Tea Urn', "Mabel's Dining Rooms"];

export const OFFICE_NAMES = [
  'Kessmouth Gazette',
  'Brannoc Shipping Agents',
  'Corran Haulage Ltd.',
  'Low Borough Labour Exchange',
  'Fairweather & Crisp Solicitors',
  'Kessmouth Mutual Assurance',
];

export const WAREHOUSE_NAMES = [
  'GULLET WHARF CO.',
  'J. TALLOW & SONS · HIDES & SKINS',
  'KESSMOUTH COLD STORE',
  'BRANNOC BONDED STORES',
  'MERROW SHIPPING LINE',
  'CORRAN HAULAGE',
  'SALT QUAY GRANARY',
  'HOLLIS BRASS WORKS',
  'CINDER YARDS FOUNDRY',
  'KESTREL STOUT BREWERY STORES',
];

export const FACTORY_NAMES = ['CINDER YARDS FOUNDRY', 'HOLLIS BRASS WORKS', 'ASHBY TANNERY', 'KESSMOUTH GAS LIGHT & COKE CO.'];

/** Painted gable-end adverts (crime-poster flavoured, period products, all invented). */
export const BILLBOARDS = [
  'KESTREL STOUT · Dark as the Docks',
  'HALCYON CIGARETTES · Cool Under Pressure',
  'BRASSO-BRITE · Shines Like New Money',
  'VESPER GT · Leave Them Standing',
  'GILT EDGE TEA · The Honest Cup',
  'MERROW RADIO · Hear Every Whisper',
];
